var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.estate.energy_data.certification_type
    ? _c(
        "div",
        { staticClass: "row border-radius bg-white padding-flex mb-1" },
        [
          _c("div", { staticClass: "col-md-12 estate-energy-data" }, [
            _c(
              "h2",
              [
                _c("masked-image", {
                  staticClass: "icon_title",
                  attrs: { src: "/img/icons/energy-data.svg" }
                }),
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm._f("capitalize")(_vm.trans("labels.energy_data"))
                    ) +
                    "\n        "
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "row",
                class: _vm.version == 1 ? "italia" : "esteri"
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "energy-graph",
                    class: { exempt: _vm.isExempt | _vm.isPending }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "square",
                        class: {
                          active:
                            _vm.estate.energy_data.class
                              .charAt(0)
                              .toLowerCase() == "a"
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(_vm.estate.energy_data.class)
                            )
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "square",
                        class: {
                          active:
                            _vm.estate.energy_data.class
                              .charAt(0)
                              .toLowerCase() == "b"
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(_vm.estate.energy_data.class)
                            )
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "square",
                        class: {
                          active:
                            _vm.estate.energy_data.class
                              .charAt(0)
                              .toLowerCase() == "c"
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(_vm.estate.energy_data.class)
                            )
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "square",
                        class: {
                          active:
                            _vm.estate.energy_data.class
                              .charAt(0)
                              .toLowerCase() == "d"
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(_vm.estate.energy_data.class)
                            )
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "square",
                        class: {
                          active:
                            _vm.estate.energy_data.class
                              .charAt(0)
                              .toLowerCase() == "e"
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(_vm.estate.energy_data.class)
                            )
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "square",
                        class: {
                          active:
                            _vm.estate.energy_data.class
                              .charAt(0)
                              .toLowerCase() == "f"
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(_vm.estate.energy_data.class)
                            )
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "square",
                        class: {
                          active:
                            _vm.estate.energy_data.class
                              .charAt(0)
                              .toLowerCase() == "g"
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(_vm.estate.energy_data.class)
                            )
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "square",
                        class: {
                          active:
                            _vm.estate.energy_data.class
                              .charAt(0)
                              .toLowerCase() == "h"
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(_vm.estate.energy_data.class)
                            )
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "square",
                        class: {
                          active:
                            _vm.estate.energy_data.class
                              .charAt(0)
                              .toLowerCase() == "i"
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(_vm.estate.energy_data.class)
                            )
                          )
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                !_vm.isExempt & !_vm.isPending
                  ? _c(
                      "div",
                      {
                        staticClass: "estate-energy-details mt-1",
                        class:
                          _vm.version == 1
                            ? "col-md-12 col-lg-6"
                            : "col-md-6 col-lg-6"
                      },
                      [
                        _c("div", { staticClass: "energy-class" }, [
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _vm.certificationType === "ape"
                                ? [
                                    _vm.estate.energy_data.ep_nren
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-sm-6 col-md-6 col-lg-12 col-xl-6"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.trans(
                                                    "energy_data.ep_nren"
                                                  )
                                                ) + ":"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-sm-6 col-md-6 col-lg-12 col-xl-6"
                                            },
                                            [
                                              _c("strong", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.estate.energy_data
                                                      .ep_nren
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.estate.energy_data.ep_ren
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-sm-6 col-md-6 col-lg-12 col-xl-6"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.trans(
                                                    "energy_data.ep_ren"
                                                  )
                                                ) + ":"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-sm-6 col-md-6 col-lg-12 col-xl-6"
                                            },
                                            [
                                              _c("strong", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.estate.energy_data
                                                      .ep_ren
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.estate.energy_data.smile_ci
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-sm-6 col-md-6 col-lg-12 col-xl-6"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.trans(
                                                    "energy_data.smile_ci"
                                                  )
                                                ) + ":"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-sm-6 col-md-6 col-lg-12 col-xl-6"
                                            },
                                            [
                                              _c("strong", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.estate.energy_data
                                                      .smile_ci
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.estate.energy_data.smile_ce
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-sm-6 col-md-6 col-lg-12 col-xl-6"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.trans(
                                                    "energy_data.smile_ce"
                                                  )
                                                ) + ":"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-sm-6 col-md-6 col-lg-12 col-xl-6"
                                            },
                                            [
                                              _c("strong", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.estate.energy_data
                                                      .smile_ce
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.estate.energy_data.zero
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-sm-6 col-md-6 col-lg-12 col-xl-6"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.trans("energy_data.zero")
                                                ) + ":"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-sm-6 col-md-6 col-lg-12 col-xl-6"
                                            },
                                            [
                                              _c("strong", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.estate.energy_data.zero
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      : _vm._e()
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.certificationType === "ace"
                                ? [
                                    _vm.estate.energy_data.efficiency
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-sm-6 col-md-6 col-lg-12 col-xl-6"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.trans("energy_data.index")
                                                ) + ":"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-sm-6 col-md-6 col-lg-12 col-xl-6"
                                            },
                                            [
                                              _c("strong", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.estate.energy_data
                                                      .efficiency
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      : _vm._e()
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              ["presente", "présent"].includes(
                                _vm.certificationType
                              )
                                ? [
                                    _vm.estate.energy_data.efficiency
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-sm-6 col-md-6 col-lg-12 col-xl-6"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.trans("energy_data.index")
                                                ) + ":"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-sm-6 col-md-6 col-lg-12 col-xl-6"
                                            },
                                            [
                                              _c("strong", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.estate.energy_data
                                                      .efficiency
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.estate.energy_data.icone_emissions ||
                                    _vm.estate.energy_data.emissions
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-sm-6 col-md-6 col-lg-12 col-xl-6"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.trans(
                                                    "energy_data.emissions"
                                                  )
                                                ) + ":"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-sm-6 col-md-6 col-lg-12 col-xl-6"
                                            },
                                            [
                                              _c("span", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.estate.energy_data
                                                      .icone_emissions
                                                  )
                                                }
                                              }),
                                              _vm._v(" "),
                                              _vm.estate.energy_data.emissions
                                                ? [
                                                    _c("strong", [
                                                      _c("span", {
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.estate
                                                              .energy_data
                                                              .emissions
                                                          )
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.trans(
                                                              "energy_data.emissions_unit"
                                                            )
                                                          )
                                                        }
                                                      })
                                                    ])
                                                  ]
                                                : _vm._e()
                                            ],
                                            2
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.estate.energy_data.certification_number
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-sm-6 col-md-6 col-lg-12 col-xl-6"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.trans(
                                                    "energy_data.certification_number"
                                                  )
                                                ) + ":"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-sm-6 col-md-6 col-lg-12 col-xl-6"
                                            },
                                            [
                                              _c("strong", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.estate.energy_data
                                                      .certification_number
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.estate.energy_data.certification_date
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-sm-6 col-md-6 col-lg-12 col-xl-6"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.trans(
                                                    "energy_data.certification_date"
                                                  )
                                                ) + ":"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-sm-6 col-md-6 col-lg-12 col-xl-6"
                                            },
                                            [
                                              _c("strong", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.estate.energy_data
                                                      .certification_date
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      : _vm._e()
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        ])
                      ]
                    )
                  : _vm.isExempt
                  ? _c("div", { staticClass: "col-md-12 col-lg-6 mt-1" }, [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.trans("energy_data.exempt")))
                      ])
                    ])
                  : _vm.isPending
                  ? _c("div", { staticClass: "col-md-12 col-lg-6 mt-1" }, [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.trans("energy_data.pending")))
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "estate-dates mt-1",
                    class:
                      _vm.version == 1
                        ? "col-md-12 col-lg-6"
                        : "col-md-6 col-lg-6"
                  },
                  [
                    _vm._l(_vm.estate.dates, function(date, key) {
                      return [
                        date
                          ? _c("div", { key: key, staticClass: "row" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-sm-6 col-md-6 col-lg-12 col-xl-6"
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.trans("dates." + key)) +
                                      ":\n                        "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-sm-6 col-md-6 col-lg-12 col-xl-6"
                                },
                                [
                                  _c("strong", {
                                    domProps: { innerHTML: _vm._s(date) }
                                  })
                                ]
                              )
                            ])
                          : _vm._e()
                      ]
                    }),
                    _vm._v(" "),
                    _vm.estate.energy_data.heating
                      ? _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-sm-6 col-md-6 col-lg-12 col-xl-6"
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.trans("energy_data.heating")) +
                                  ":\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-sm-6 col-md-6 col-lg-12 col-xl-6"
                            },
                            [
                              _c("strong", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.estate.energy_data.heating
                                  )
                                }
                              })
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.estate.energy_data.heating_type
                      ? _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-sm-6 col-md-6 col-lg-12 col-xl-6"
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.trans("energy_data.heating_type")
                                  ) +
                                  ":\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-sm-6 col-md-6 col-lg-12 col-xl-6"
                            },
                            [
                              _c("strong", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.estate.energy_data.heating_type
                                  )
                                }
                              })
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.estate.energy_data.heating_power
                      ? _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-sm-6 col-md-6 col-lg-12 col-xl-6"
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.trans("energy_data.heating_power")
                                  ) +
                                  ":\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-sm-6 col-md-6 col-lg-12 col-xl-6"
                            },
                            [
                              _c("strong", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.estate.energy_data.heating_power
                                  )
                                }
                              })
                            ]
                          )
                        ])
                      : _vm._e()
                  ],
                  2
                )
              ]
            )
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }